/*
 * Definizione dei livelli di log e logica di confronto tra priorità.
 *
 * Questo modulo è puramente dichiarativo: contiene l'enum dei livelli,
 * la mappa delle priorità numeriche e le funzioni di confronto.
 * Non ha effetti collaterali né dipendenze esterne.
 */

/**
 * Livelli di log supportati dall'applicazione.
 * Ordinati dal meno critico (Debug) al più critico (Error).
 */
export enum LogLevel {
    Debug = "debug",
    Info = "info",
    Warn = "warn",
    Error = "error",
}

/**
 * Priorità numerica associata a ciascun livello.
 * Un valore più alto indica un livello più critico.
 * Usata internamente per decidere se un messaggio deve essere emesso.
 */
const levelPriority: Record<LogLevel, number> = {
    [LogLevel.Debug]: 0,
    [LogLevel.Info]: 1,
    [LogLevel.Warn]: 2,
    [LogLevel.Error]: 3,
};

/**
 * Restituisce la priorità numerica di un livello di log.
 */
export function getPriority(level: LogLevel): number {
    return levelPriority[level];
}

/**
 * Verifica se un messaggio al livello `level` dovrebbe essere mostrato,
 * dato il livello minimo `minLevel`.
 *
 * Esempio: isLevelEnabled(LogLevel.Warn, LogLevel.Info) → true
 *          isLevelEnabled(LogLevel.Debug, LogLevel.Info) → false
 */
export function isLevelEnabled(level: LogLevel, minLevel: LogLevel): boolean {
    return levelPriority[level] >= levelPriority[minLevel];
}
